module.exports = __webpack_public_path__ + "img/icon-png.dc7e0d74.svg";